module.exports = __webpack_public_path__ + "915bebc9ead1ee43f188925f331ca212.jpg";